import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ContainerList  {
    _originalTypeClassName = "zAppDevManager.BO.ContainerList";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ContainerList.translate = translateService;
}
this.Name = null;
this.Id = null;
this.User = null;
this.VsCode = false;
this.DbGate = false;
this.State = null;
this.Status = null;
this.ContainerListKey = null;
this._key = this.ContainerListKey = 0; 
}

static translate: TranslateService;
_key: any;
Name:any;
Id:any;
User:any;
VsCode:any;
DbGate:any;
State:any;
Status:any;
private _ContainerListKey:any;
get ContainerListKey(): any {
    return this._ContainerListKey;
  }
set ContainerListKey(value: any) {
    this._ContainerListKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ContainerListKey == null || $this.ContainerListKey == 0;
            }


}